import React from 'react';
import { Box } from '@material-ui/core';
import { SelectButtonOption } from '../../common/SelectButtons/SelectButtons';

type Props = {
    tabs: SelectButtonOption[];
    selectedTab: SelectButtonOption;
    keepMountedTabValues: SelectButtonOption['value'][];
    renderTabContent: (tabValue: SelectButtonOption['value']) => React.ReactNode;
};

const PrescriptionTabsContent = ({
    tabs,
    selectedTab,
    keepMountedTabValues,
    renderTabContent,
}: Props) => {
    return (
        <>
            {tabs.map((tab) => {
                const tabSelected = selectedTab.value === tab.value;
                const shouldKeepMounted = keepMountedTabValues.includes(tab.value);
                const shouldRender = tabSelected || shouldKeepMounted;

                if (!shouldRender) return null;

                return (
                    <Box key={tab.value} style={{ display: tabSelected ? 'block' : 'none' }}>
                        {renderTabContent(tab.value)}
                    </Box>
                );
            })}
        </>
    );
};

export default PrescriptionTabsContent;